module.exports = __webpack_public_path__ + "static/before-a743a4c56ce310f674ffe4a26a917920.png";